
//import testiImg from '../../assets/images/testimonial/testimonial.png';

const SingleTestimonial = (props) => {
	const { itemClass, itemImg, Title, Designation, Desc, ratingCount, reviewCount, comaImg } = props;
    return (
        <div className={itemClass ? itemClass : 'single-client'}>
           
            <div class="client-bottom" style={{ width: '55%',}}>   
                <span class="client-author">
                <img 
                    src= {itemImg} 
                    alt="Image"
                   // width={590}
                   // height={600}
                    className='schoolImg'
                />
                </span>
            </div>                                    
           
            <div class="client-content"  style={{ width: '45%',}}>
                <span class="client-title">{Title ? Title : ''} 
                    <em> {Designation ? Designation : ''}</em></span>
                
                <p>{Desc ? Desc : '.'}</p>
                
                <div class="testimonial__ratings">
                    <em class="icon_star"></em>
                    <em class="icon_star"></em>
                    <em class="icon_star"></em>
                    <em class="icon_star"></em>
                    <em class="icon_star_alt"></em>
                    <span>
                        <em> 
                        {ratingCount ? ratingCount : '4.9'}
                        </em> ({reviewCount ? reviewCount : '14'} Reviews)
                    </span>
                </div>
                <img 
                    className="comma" 
                    src= {comaImg} 
                    alt="Coma"
                />
            </div>  
        </div>
    )
}

export default SingleTestimonial